// Delivery-time estimate. Bulk items flagged `fastDelivery` are ready-to-go, so an
// order made up ENTIRELY of fast items is promised in about half the usual time.
import type { CartLine } from "./types";

export const NORMAL_ETA_MIN = 45;
export const FAST_ETA_MIN = Math.round(NORMAL_ETA_MIN / 2 / 5) * 5; // ~25, rounded to 5

/** True when every line in the cart is a fast-delivery item. */
export function isAllFast(lines: CartLine[]): boolean {
  return lines.length > 0 && lines.every((l) => l.fastDelivery === true);
}

/** True when at least one (but not every) line qualifies for fast delivery. */
export function hasFast(lines: CartLine[]): boolean {
  return lines.some((l) => l.fastDelivery === true);
}

export interface Eta {
  minutes: number;
  fast: boolean;
}

export function deliveryEta(lines: CartLine[]): Eta {
  const fast = isAllFast(lines);
  return { minutes: fast ? FAST_ETA_MIN : NORMAL_ETA_MIN, fast };
}
